import React, {useCallback, useEffect, useRef, useState} from 'react'
import {Button, Col, Container, Form, FormControl, FormLabel, Modal, Row} from "react-bootstrap";
import {isValid} from "../../scripts/myga-session";
import {NassauLog} from "../../scripts/myga-utils";
import PopoverTooltip from "../../components/PopoverTooltip";
import {v4 as uuidv4} from "uuid";

const DownloadModal = props => {
  let propShow = isValid(props.show) ? props.show : false
  let [show, setShow] = useState(propShow)
  let modalForm = useRef(null)
  let [testTitle, setTestTitle] = useState('')
  let [testDesc, setTestDesc] = useState('')
  let [testPath, setTestPath] = useState('')
  let [testAuthor, setTestAuthor] = useState('')
  let [testID, setTestID] = useState('')
  
  const clearForm = useRef(() => {
    setTestTitle('')
    setTestDesc('')
    setTestPath('')
    setTestAuthor('')
    setTestID('')
  })

  useEffect(() => {
    if (propShow) clearForm.current()
    setShow(propShow)
  }, [propShow])

  const validateForm = useCallback(() => {
    if (!modalForm.current.checkValidity()) {
      modalForm.current.classList.add('was-validated');
      return false;
    }
    return true
  }, [])

  const handleSave = useCallback(() => {
    if (!validateForm()) return
    
    props.handleSave({
      title: testTitle,
      desc: testDesc,
      path: testPath,
      author: testAuthor,
      testID: (testID.length>0 ? `p${testPath}${testID}` : uuidv4()),
      createdOn: new Date()
    })
  }, [props, testID, testAuthor, testDesc, testPath, testTitle, validateForm])

  const handleChange = useCallback(stateFn => ({target}) => stateFn(target.value),[])

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={props.onHide}
    >

      <Modal.Header closeButton>
        <Modal.Title>Test Case Information</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form className={'needs-validation'}
              ref={modalForm}>
          <Container className={'download-modal-form-container col-12 col-lg-7'}>
            <Row>
              <Col>
                <FormLabel htmlFor={'test_meta_title'}>Title</FormLabel>
                <FormControl id={'test_meta_title'}
                             value={testTitle}
                             onChange={handleChange(setTestTitle)}
                             required/>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormLabel htmlFor={'test_meta_desc'}>Description</FormLabel>
                <FormControl id={'test_meta_desc'}
                             value={testDesc}
                             onChange={handleChange(setTestDesc)}
                             required/>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormLabel htmlFor={'test_meta_path'}>
                  Path
                  &nbsp;
                  <PopoverTooltip
                    title={'Path Description'}
                    content={'TODO: add path descriptions'} />
                </FormLabel>
                <select id={'test_meta_path'}
                        className={'form-control'}
                        value={testPath}
                        onChange={handleChange(setTestPath)}
                        required>
                  <option/>
                  <option>A</option>
                  <option>B</option>
                  <option>C</option>
                </select>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormLabel htmlFor={'test_meta_id'}>Test ID (optional)</FormLabel>
                <FormControl id={'test_meta_id'}
                             value={testID}
                             onChange={handleChange(setTestID)}
                             />
              </Col>
            </Row>
            <Row>
              <Col>
                <FormLabel htmlFor={'test_meta_author'}>Author</FormLabel>
                <FormControl id={'test_meta_author'}
                             value={testAuthor}
                             onChange={handleChange(setTestAuthor)}
                             required/>
              </Col>
            </Row>
          </Container>
        </Form>
      </Modal.Body>

      <Modal.Footer style={{justifyContent: 'space-between', flexWrap: 'nowrap'}}>
        <Button id={'test_meta_cancel'} variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button id={'test_meta_save'} variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DownloadModal